// Shared color/typography tokens, kept dependency-free (no react-router-dom,
// no component imports) so pure presentation-logic modules — and their unit
// tests — can import colors without dragging in the whole component graph.
// DashboardLayout.js re-exports these for backward compatibility with every
// page that already does `import { V } from '../components/DashboardLayout'`.

export const V = {
  bg:      '#F5F7FB',
  surface: '#FFFFFF',
  hover:   '#F8FAFC',
  border:  '#DCE3EC',
  accent:  '#2F81F4',
  success: '#16A34A',
  error:   '#DC2626',
  warn:    '#D97706',
  text:    '#0F1E35',
  sub:     '#64748B',
  dim:     '#94A3B8',
  mono:    "'JetBrains Mono', 'Fira Code', 'Courier New', monospace",
  sans:    "'Space Grotesk', -apple-system, BlinkMacSystemFont, sans-serif",
};

// Dark "PaySafe-aligned" palette — the shared visual system for the whole
// customer-facing app (sampled from the TrustTrade Premium Redesign Figma
// file, "PaySafe Aligned V2" frame). Opt in per page via DashboardLayout's
// `darkMain` prop. Deliberately NOT merged into `V` above: admin/internal
// screens still use V and are out of scope for this pass. Every customer
// route should import VDark (directly, or via the shared components in
// ./customerUi.js) rather than inventing its own colors.
//
// No color here is used as ambient/decorative page lighting — error/warn
// are reserved for genuine dispute/attention states on their own small
// elements (pills, borders), never as a diffuse page-wide or button glow.
export const VDark = {
  bg:        '#060607',
  bgGlow:    'radial-gradient(ellipse 1100px 560px at 50% -8%, #0B2E3D 0%, #0A0C0E 45%, #060607 100%)',
  surface:   'rgba(22,24,27,0.68)',
  surfaceSolid: '#16181B',
  hover:     'rgba(255,255,255,0.05)',
  border:    'rgba(255,255,255,0.10)',
  accent:    '#2F9BFF',
  accentGradient: 'linear-gradient(135deg, #178FE3 0%, #54B8FF 100%)',
  success:   '#3DD194',
  error:     '#F0665C',
  warn:      '#F5AB1F',
  warnText:  '#1A170F',
  text:      '#F5F7FA',
  sub:       '#9AA4B2',
  dim:       '#6B7280',
  mono:      V.mono,
  sans:      V.sans,
  // Neutral depth shadow — use for all elevated surfaces/buttons instead of
  // a color-tinted shadow (which reads as a decorative glow).
  shadow:    '0 8px 24px rgba(0,0,0,0.35)',
  radius:    16,
  radiusSm:  12,
};
